import qs from "qs";
import axios from "axios";
import { URL, API_URL } from "../../../../constants/Constants";

/**
 * Obtiene lista de procesos
 * @param {string} screenName - Nombre de la pantalla
 * @param {string} type - Tipo de consulta
 * @param {number} currentScreenId - ID de la pantalla actual
 * @returns {Promise<Array|false>} Lista de procesos o false si hay error
 */
export const getListProcesos = async (screenName, type, currentScreenId) => {
  const queryData = {
    action: type,
    query_type: currentScreenId,
    screenName: screenName,
  };
  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      console.log("lista de procesos correcta");
      return response.data.data;
    } else {
      console.log("Error en la lista de procesos");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene lista de referencias actuales
 * @param {string} query_param - Parámetro de consulta
 * @param {string} queryType - Tipo de consulta
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const getListRefActu = async (query_param, queryType) => {
  const queryData = {
    query_param: query_param,
    query_type: queryType,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("nuevo tiempo no insertado");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene referencias
 * @param {string} type - Tipo (mantenido por compatibilidad, no se usa)
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @param {number} currentScreenId - ID de la pantalla actual (mantenido por compatibilidad, no se usa)
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const getReferencias = async (type, typeConnect, currentScreenId) => {
  const queryData = {
    screen: "referencias",
    action: "get_referencias",
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));

    let responseData = response.data;

    // Manejar respuesta que puede venir como string JSON
    if (typeof responseData === 'string' && responseData.includes('{')) {
      try {
        const jsonStart = responseData.indexOf('{');
        const jsonString = responseData.substring(jsonStart);
        responseData = JSON.parse(jsonString);
      } catch (parseError) {
        console.error("Error al parsear JSON de la respuesta:", parseError);
        return false;
      }
    }

    if (responseData.status === "ok" || responseData.status === "success" || responseData.status === "Success") {
      return responseData.data || responseData;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene precio total de procesos
 * @param {string} query_param - Parámetro de consulta
 * @param {string} queryType - Tipo de consulta
 * @param {string} fechaInicioSQL - Fecha de inicio SQL
 * @param {string} fechaFinSQL - Fecha de fin SQL
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const getPrecioProcesosTotal = async (
  query_param,
  queryType,
  fechaInicioSQL,
  fechaFinSQL
) => {
  const queryData = {
    query_param: query_param,
    query_type: queryType,
    fechaInicioSQL: fechaInicioSQL,
    fechaFinSQL: fechaFinSQL,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Error");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
